import React, { useState, useContext, useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashBoardSVG from "../../../SVG/DashBoardSVG";
import SystemLogSvg from "../../../SVG/SystemLog";
import StAcc from "../../../SVG/StAcc";
import ShpList from "../../../SVG/ShpList";
import ScheduleIcon from "../../../SVG/ScheduleIcon";
import "./Sidebar.css";
import { StoreContext } from "../../../../Store/Provider";
import MenuBars from "../../../SVG/MenuBars";
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import AccountCircleRoundedIcon from "@material-ui/icons/AccountCircleRounded";
import Whatsapp from "../../../SVG/Whatsapp";
import { version } from "../../../../Config";
import { routeConstant } from "../../../../Route/utils/routeConstant";
import { localStoragekey } from "./../../../Common/Utility/Utils";
import Tooltip from "@mui/material/Tooltip";
import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import Createorder from "../../../SVG/createOrder";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import LoginIcon from "@mui/icons-material/Login";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import {
  IsShowOutstanding,
  IsShowShipment,
  IsShowOrder,
} from "../../../../utils/index";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

function Sidebar() {
  const url = useLocation();
  const history = useNavigate();
  const context = useContext(StoreContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showUser, setShowUser] = useState(false);
  const [showOrder, setShowOrder] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const userdata = JSON.parse(localStorage.getItem(localStoragekey));
    if (userdata) {
      if (
        userdata.role.includes("SuperAdmin") ||
        userdata.role.includes("Admin")
      ) {
        setShowUser(true);
      } else {
        setShowUser(false);
      }
    }
  }, []);

  const logOut = () => {
    handleClose();
    context.setIsUserLogin(false);
    localStorage.removeItem("sfl_user_data");
    history("/");
    window.location.reload();
  };

  useEffect(() => {
    const handleInvalidToken = (e) => {
      console.log(e);
      if (e.key === "sfl_user_data" && e.oldValue && !e.newValue) {
        logOut();
      }
    };
    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, [logOut]);

  const updatePassword = () => {
    handleClose();
    history(routeConstant.UpdatePassword);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const startTour = () => {
    context.SetRun(true);
  };

  const number = context.isUserLogin
    ? JSON.parse(localStorage.getItem(localStoragekey))?.CSContact
    : "+918130552650";

  return (
    <div className="tabsName">
      <List>
        {url.pathname.includes(routeConstant.BlogSFL) ? (
          <ListItem
            id="first"
            onClick={context.handleMenubar}
            style={{ height: "3rem", paddingLeft: "0.5rem" }}
          >
            <ListItemIcon className="sidebaricon">
              <MenuBars
                classMenu={" menuBarIcon"}
                colorCode={"rgba(var(--text-heading-dark))"}
              />
            </ListItemIcon>
          </ListItem>
        ) : (
          ""
        )}
        {!context.isUserLogin && (
          <>
            <Link to={routeConstant.BlogSFL}>
              <Tooltip
                disableFocusListener
                disableTouchListener
                placement="right"
                disableHoverListener={context.menuBar}
                arrow
                title="Home"
              >
                <ListItem
                  className={
                    url.pathname.includes(routeConstant.BlogSFL)
                      ? "selected"
                      : ""
                  }
                >
                  <ListItemIcon className="sidebaricon">
                    {url.pathname.includes(routeConstant.BlogSFL) ? (
                      <HomeOutlinedIcon style={{ color: "#fff" }} />
                    ) : (
                      <HomeOutlinedIcon
                        style={{ color: "rgba(var(--text-heading-dark))" }}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText>Home</ListItemText>
                </ListItem>
              </Tooltip>
            </Link>
            <Link to={routeConstant.Login}>
              <Tooltip
                disableFocusListener
                disableTouchListener
                placement="right"
                disableHoverListener={context.menuBar}
                arrow
                title="Login"
              >
                <ListItem
                  className={
                    url.pathname.includes(routeConstant.Login) ? "selected" : ""
                  }
                >
                  <ListItemIcon className="sidebaricon">
                    {url.pathname.includes(routeConstant.Login) ? (
                      <LoginIcon style={{ color: "#fff" }} />
                    ) : (
                      <LoginIcon
                        style={{ color: "rgba(var(--text-heading-dark))" }}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText>Login</ListItemText>
                </ListItem>
              </Tooltip>
            </Link>
          </>
        )}
        {context.isUserLogin && (
          <>
            <Link to={routeConstant.BlogSFL}>
              <Tooltip
                disableFocusListener
                disableTouchListener
                placement="right"
                disableHoverListener={context.menuBar}
                arrow
                title="Home"
              >
                <ListItem
                  className={
                    url.pathname.includes(routeConstant.BlogSFL)
                      ? "selected"
                      : ""
                  }
                >
                  <ListItemIcon className="TourfirstStep sidebaricon">
                    {url.pathname.includes(routeConstant.BlogSFL) ? (
                      <HomeOutlinedIcon style={{ color: "#fff" }} />
                    ) : (
                      <HomeOutlinedIcon
                        style={{ color: "rgba(var(--text-heading-dark))" }}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    className={!context.menuBar ? "display_none" : ""}
                  >
                    Home
                  </ListItemText>
                </ListItem>
              </Tooltip>
            </Link>
          </>
        )}
        <Link to={{ pathname: routeConstant.Schedule, state: "link state" }}>
          <Tooltip
            disableFocusListener
            disableTouchListener
            placement="right"
            disableHoverListener={context.menuBar}
            arrow
            title={context.isUserLogin ? "General Enquiry" : "Inquiry"}
          >
            <ListItem
              className={
                url.pathname.includes(routeConstant.Schedule) ? "selected" : ""
              }
            >
              <ListItemIcon className="ToursecondStep sidebaricon">
                {url.pathname.includes(routeConstant.Schedule) ? (
                  <ScheduleIcon colorCode={"#fff"} />
                ) : (
                  <ScheduleIcon colorCode={"rgba(var(--text-heading-dark))"} />
                )}
              </ListItemIcon>
              <ListItemText className={!context.menuBar ? "display_none" : ""}>
                {context.isUserLogin ? "General Enquiry" : "Inquiry"}
              </ListItemText>
            </ListItem>
          </Tooltip>
        </Link>

        {context.isUserLogin && (
          <Link className="TourfifthStep" to={routeConstant.EnquiryDashboard}>
            <Tooltip
              disableFocusListener
              disableTouchListener
              placement="right"
              disableHoverListener={context.menuBar}
              arrow
              title="Enquiry Dashboard"
            >
              <ListItem
                className={
                  url.pathname.includes(routeConstant.EnquiryDashboard)
                    ? "selected"
                    : ""
                }
              >
                <ListItemIcon className="sidebaricon">
                  {url.pathname.includes(routeConstant.EnquiryDashboard) ? (
                    <FormatListBulletedOutlinedIcon
                      style={{ color: "#fff" }}
                      // colorCode={"#fff"}
                    />
                  ) : (
                    <FormatListBulletedOutlinedIcon
                      style={{ color: "rgba(var(--text-heading-dark))" }}
                      // colorCode={"rgba(var(--text-heading-dark))"}
                    />
                  )}
                </ListItemIcon>
                <ListItemText
                  className={!context.menuBar ? "display_none" : ""}
                >
                  Enquiry Dashboard
                </ListItemText>
              </ListItem>
            </Tooltip>
          </Link>
        )}

        {context.isUserLogin && IsShowShipment() ? (
          <Link className="TourfifthStep" to={routeConstant.ShipmentsListing}>
            <Tooltip
              disableFocusListener
              disableTouchListener
              placement="right"
              disableHoverListener={context.menuBar}
              arrow
              title="Your Shipments"
            >
              <ListItem
                className={
                  url.pathname.includes(routeConstant.ShipmentsListing)
                    ? "selected"
                    : ""
                }
              >
                <ListItemIcon className="sidebaricon">
                  {url.pathname.includes(routeConstant.ShipmentsListing) ? (
                    <ShpList colorCode={"#fff"} />
                  ) : (
                    <ShpList colorCode={"rgba(var(--text-heading-dark))"} />
                  )}
                </ListItemIcon>
                <ListItemText
                  className={!context.menuBar ? "display_none" : ""}
                >
                  Your Shipments
                </ListItemText>
              </ListItem>
            </Tooltip>
          </Link>
        ) : (
          <Link to={routeConstant.SearchShipment}>
            <Tooltip
              disableFocusListener
              disableTouchListener
              placement="right"
              disableHoverListener={context.menuBar}
              arrow
              title="Search Shipment"
            >
              <ListItem
                className={
                  url.pathname.includes(routeConstant.SearchShipment)
                    ? "selected"
                    : ""
                }
              >
                <ListItemIcon className="sidebaricon">
                  {url.pathname.includes(routeConstant.SearchShipment) ? (
                    <ShpList colorCode={"#fff"} />
                  ) : (
                    <ShpList colorCode={"rgba(var(--text-heading-dark))"} />
                  )}
                </ListItemIcon>
                <ListItemText
                  className={!context.menuBar ? "display_none" : ""}
                >
                  Search Shipment
                </ListItemText>
              </ListItem>
            </Tooltip>
          </Link>
        )}
        {context.isUserLogin && (
          <>
            {IsShowOutstanding() && (
              <Link to={routeConstant.Statement}>
                <Tooltip
                  disableFocusListener
                  disableTouchListener
                  placement="right"
                  disableHoverListener={context.menuBar}
                  arrow
                  title="Statement of Account"
                >
                  <ListItem
                    className={
                      url.pathname === routeConstant.Statement ? "selected" : ""
                    }
                  >
                    <ListItemIcon className="ToureighteenthStep sidebaricon">
                      {url.pathname === routeConstant.Statement ? (
                        <StAcc colorCode={"#fff"} />
                      ) : (
                        <StAcc colorCode={"rgba(var(--text-heading-dark))"} />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      className={!context.menuBar ? "display_none" : ""}
                    >
                      Statement of Account
                    </ListItemText>
                  </ListItem>
                </Tooltip>
              </Link>
            )}
            <Link to={routeConstant.Dashboard}>
              <Tooltip
                disableFocusListener
                disableTouchListener
                placement="right"
                disableHoverListener={context.menuBar}
                arrow
                title="Your Dashboard"
              >
                <ListItem
                  className={
                    url.pathname === routeConstant.Dashboard ? "selected" : ""
                  }
                >
                  <ListItemIcon className="TournineteenthStep sidebaricon">
                    {url.pathname === routeConstant.Dashboard ? (
                      <DashBoardSVG colorCode={"#fff"} />
                    ) : (
                      <DashBoardSVG
                        colorCode={"rgba(var(--text-heading-dark))"}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    className={!context.menuBar ? "display_none" : ""}
                  >
                    Your Dashboard
                  </ListItemText>
                </ListItem>
              </Tooltip>
            </Link>

            <div
              style={{ display: "flex" }}
              onClick={() => {
                setShowOrder(!showOrder);
              }}
              title="Order"
            >
              <div style={{ padding: "0.5rem" }}>
                {!showOrder ? (
                  <ExpandLessOutlinedIcon />
                ) : (
                  <ExpandMoreOutlinedIcon />
                )}
              </div>
              <div
                style={{ paddingTop: "0.5rem" }}
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
                className={!context.menuBar ? "display_none" : ""}
              >
                Order
              </div>
            </div>
            <div
              className={!showOrder ? "collapse" : "collapse show"}
              id="collapseExample"
            >
              {IsShowOrder() && (
                <>
                  <Link to={routeConstant.ORDER_DASHBOARD}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Order Dashboard"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.ORDER_DASHBOARD
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.ORDER_DASHBOARD ? (
                            <DashboardCustomizeOutlinedIcon
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            <DashboardCustomizeOutlinedIcon
                              style={{
                                color: "rgba(var(--text-heading-dark))",
                              }}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Order Dashboard
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.ORDER_LIST}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Order List"
                    >
                      <ListItem
                        className={
                          url.pathname.includes("order-list") ? "selected" : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname.includes(routeConstant.ORDER_LIST) ? (
                            <ListAltIcon style={{ color: "#fff" }} />
                          ) : (
                            <ListAltIcon
                              style={{
                                color: "rgba(var(--text-heading-dark))",
                              }}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Order List
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.CREATE_ORDER}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Create New Order"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.CREATE_ORDER
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.CREATE_ORDER ? (
                            <Createorder colorCode={"#fff"} />
                          ) : (
                            <Createorder
                              colorCode={"rgba(var(--text-heading-dark))"}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Create New Order
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.REPORTS}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Reports"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.REPORTS
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.REPORTS ? (
                            <AddchartOutlinedIcon style={{ color: "#fff" }} />
                          ) : (
                            <AddchartOutlinedIcon
                              style={{
                                color: "rgba(var(--text-heading-dark))",
                              }}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Reports
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.SYSTEM_LOG}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="System Log"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.SYSTEM_LOG
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.SYSTEM_LOG ? (
                            <SystemLogSvg colorCode={"#fff"} />
                          ) : (
                            <SystemLogSvg
                              colorCode={"rgba(var(--text-heading-dark))"}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          System Log
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                </>
              )}
            </div>
            {/* <details className="detailssummary">
              <summary>Order</summary>

              {IsShowOrder() && (
                <>
                  <Link to={routeConstant.ORDER_DASHBOARD}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Order Dashboard"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.ORDER_DASHBOARD
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.ORDER_DASHBOARD ? (
                            <DashboardCustomizeOutlinedIcon
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            <DashboardCustomizeOutlinedIcon
                              style={{
                                color: "rgba(var(--text-heading-dark))",
                              }}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Order Dashboard
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.ORDER_LIST}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Order List"
                    >
                      <ListItem
                        className={
                          url.pathname.includes("order-list") ? "selected" : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname.includes(routeConstant.ORDER_LIST) ? (
                            <ListAltIcon style={{ color: "#fff" }} />
                          ) : (
                            <ListAltIcon
                              style={{
                                color: "rgba(var(--text-heading-dark))",
                              }}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Order List
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.CREATE_ORDER}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Create New Order"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.CREATE_ORDER
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.CREATE_ORDER ? (
                            <Createorder colorCode={"#fff"} />
                          ) : (
                            <Createorder
                              colorCode={"rgba(var(--text-heading-dark))"}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Create New Order
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.REPORTS}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="Reports"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.REPORTS
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.REPORTS ? (
                            <AddchartOutlinedIcon style={{ color: "#fff" }} />
                          ) : (
                            <AddchartOutlinedIcon
                              style={{
                                color: "rgba(var(--text-heading-dark))",
                              }}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          Reports
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                  <Link to={routeConstant.SYSTEM_LOG}>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      placement="right"
                      disableHoverListener={context.menuBar}
                      arrow
                      title="System Log"
                    >
                      <ListItem
                        className={
                          url.pathname === routeConstant.SYSTEM_LOG
                            ? "selected"
                            : ""
                        }
                      >
                        <ListItemIcon className="TournineteenthStep sidebaricon">
                          {url.pathname === routeConstant.SYSTEM_LOG ? (
                            <SystemLogSvg colorCode={"#fff"} />
                          ) : (
                            <SystemLogSvg
                              colorCode={"rgba(var(--text-heading-dark))"}
                            />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={!context.menuBar ? "display_none" : ""}
                        >
                          System Log
                        </ListItemText>
                      </ListItem>
                    </Tooltip>
                  </Link>
                </>
              )}
            </details> */}

            {showUser ? (
              <Link to={routeConstant.Users}>
                <Tooltip
                  disableFocusListener
                  disableTouchListener
                  placement="right"
                  disableHoverListener={context.menuBar}
                  arrow
                  title="Users"
                >
                  <ListItem
                    className={
                      url.pathname === routeConstant.Users ? "selected" : ""
                    }
                  >
                    <ListItemIcon className="sidebaricon TourTwentysecondStep">
                      {url.pathname === routeConstant.Users ? (
                        <PeopleOutlineOutlinedIcon style={{ color: "#fff" }} />
                      ) : (
                        <PeopleOutlineOutlinedIcon
                          style={{ color: "rgba(var(--text-heading-dark))" }}
                        />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      className={!context.menuBar ? "display_none" : ""}
                    >
                      Users
                    </ListItemText>
                  </ListItem>
                </Tooltip>
              </Link>
            ) : null}
          </>
        )}
        <a
          href={`https://web.whatsapp.com/send?phone=${number}`}
          target="_blank"
        >
          <Tooltip
            disableFocusListener
            disableTouchListener
            placement="right"
            disableHoverListener={context.menuBar}
            arrow
            title="Message Us"
          >
            <ListItem>
              <ListItemIcon className="TourTwentyfirstStep sidebaricon">
                <Whatsapp colorCode={"#3db924"} />
              </ListItemIcon>
              <ListItemText className={!context.menuBar ? "display_none" : ""}>
                Message Us
              </ListItemText>
            </ListItem>
          </Tooltip>
        </a>
      </List>
      <div className="sidebarfooter">
        {context.isUserLogin && url.pathname.includes(routeConstant.BlogSFL) && (
          <div className="user_notify insidebar">
            {context.isUserLogin && (
              <AccountCircleRoundedIcon onClick={handleClick} />
            )}
            <StyledMenu
              id="mailMenubottom"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={startTour}>Start Product Tour</MenuItem>
              <MenuItem onClick={updatePassword}>Change Password</MenuItem>
              <MenuItem onClick={logOut}>Log Out</MenuItem>
            </StyledMenu>
          </div>
        )}
        <div className="appVersion">{version}</div>
      </div>
    </div>
  );
}

export default Sidebar;
